import React, { Component } from 'react';
import { Card, CardText, CardBody, CardTitle, Button, Form, FormGroup, FormText, Label, Input, Col, Row } from 'reactstrap';

export class SignUpLogIn extends Component {
    static displayName = SignUpLogIn.name;

    constructor(props) {
        super(props);
    }


    render() {
        return (
            <div className="LogIn">
                <h1 className="text-center">Placeholder H1</h1>
                <div id="LogInFailed">
                    <Row className="justify-content-center">
                        <Col xs={12} md={6}>
                            
                            <p>Thank you for signing up with Sun Loan. Sign in to complete your registration and view your new account.</p>
                        </Col>
                    </Row>
                </div>
                <Row className="justify-content-center">
                    <Col xs={12} md={6}>
                        <Card>
                            <CardBody className="noPadBottom">
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="log-in-email" >Email</Label>
                                                <Input type="text" name="email" id="log-in-email" placeholder="" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup className="noPadBottom">
                                                <Label for="log-in-password" >Password</Label>
                                                <Input type="text" name="password" id="log-in-password" placeholder="" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="text-center">
                                        <Col>
                                            <Button className="inPanel" outline color="secondary" size="md">Send Me the Link</Button>
                                        </Col>
                                    </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/subcomponents/SignUpLogIn.js